const imgConstant = "https://gong-wei.oss-cn-hangzhou.aliyuncs.com/";

export default imgConstant;
